import {create} from 'zustand'
import {acionsTypesuser, Action, Dispatch} from '../../logic/actionsType'
import {
  IUserDetail,
  IUserProfile,
  IEmployeeInsurance,
  IPlace,
  IBoardOfDirector,
  ILegalShareHolder,
} from '../../../interfaces'

export type TReqesutState = {
  userDetail?: IUserDetail | undefined
  userProfile?: IUserProfile | undefined
  listEmployeeInsurance?: IEmployeeInsurance[]
  listPlacesCompany?: IPlace[]
  listBoardOfDirector?: IBoardOfDirector[]
  listBoardOfDirectorFacilities?: IBoardOfDirector[]
  listLegalShareHolder?:ILegalShareHolder[]
}

type State = {
  state: TReqesutState
}

const reducer = (
  state: State,
  action: Action<keyof typeof acionsTypesuser, TReqesutState>
): State => {
  switch (action.type) {
    case 'SET_USER_DETAIL_DATA':
      return {state: {...state.state, userDetail: action.payload.userDetail}}
    case 'SET_USER_PROFILE_DATA':
      return {state: {...state.state, userProfile: action.payload.userProfile}}
    case 'SET_EMPLOPEE_INSURANCE_DATA':
      return {state: {...state.state, listEmployeeInsurance: action.payload.listEmployeeInsurance}}
    case 'SET_COMPANY_PLACES_DATA':
      return {state: {...state.state, listPlacesCompany: action.payload.listPlacesCompany}}
    case 'SET_BOARD_OF_DIRECTOR_DATA':
      return {state: {...state.state, listBoardOfDirector: action.payload.listBoardOfDirector}}
      case 'SET_LEGAL_SHARE_HOLDER_DATA':
      return {state: {...state.state, listLegalShareHolder: action.payload.listLegalShareHolder}}
      case 'SET_BOARD_OF_DIRECTOR_FACILITIES_DATA':
        return {state: {...state.state, listBoardOfDirectorFacilities: action.payload.listBoardOfDirectorFacilities}}
    default:
      return state
  }
}

export const useUserDetailStore = create<
  State & Dispatch<keyof typeof acionsTypesuser, TReqesutState>
>((set) => ({
  state: {
    menuCountInfo: undefined,
    listEmployeeInsurance: [],
    listPlacesCompany: [],
    userDetail: undefined,
    userProfile: undefined,
    listBoardOfDirector: [],
    listLegalShareHolder: [],
    listBoardOfDirectorFacilities: []
  },
  dispatch: (action) => {
    set((state: State) => reducer(state, action))
  },
}))
